import { Suspense, lazy, useState } from "react";
import check from "../../../assets/images/check.svg";
import slthree from "../../../assets/images/banner123.webp";
import sltwo from "../../../assets/images/sltwo2.webp";
import bannernew from "../../../assets/images/Header.png";

// import Slider from "react-slick";
import styles from "../styles/home.module.css";

import { useNavigate } from "react-router-dom";
import useAuth from "../../../lib/hooks/useAuth";
import Slider from "react-slick";
import { STRINGS } from "../../../constants/strings";
// const Slider = lazy(() => import("react-slick"));
interface HomeBannerProps {
  bannerEsim: any;
}
const HomeBanner: React.FC<HomeBannerProps> = ({ bannerEsim }) => {
  const [loader, setLoader] = useState(false);

  const bundles = Array.from({ length: 3 }, () => bannerEsim).flat();
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  // var settings = {
  //   dots: true,
  //   arrow: false,
  //   pauseOnHover: false,
  //   infinite: true,
  //   loop: true,
  //   speed: 300,
  //   fade: true,
  //   cssEase: "linear",
  //   autoplay: true,
  //   // autoplaySpeed:3000,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  // };

  return (
    <section className={styles.BannerSection}>
      {/* {loader && <MainLoader />} */}
      <div className="homeSlids">
        {/* <Suspense fallback={<div>Loading...</div>}> */}

        <div className={styles.outreHomeside}>
          <img
            className={styles.bnrImage}
            width="1920"
            height="310"
            src={bannernew}
            alt="Tourism eSim"
          />
          <div className={styles.innerHomeSlide}>
            <div className="row">
              <div className="col-md-4"></div>
              <div className="col-md-8">
                {/* <div className={`${styles.dotsone} ${styles.innerHomeSlideRight}`}>
                    <div className={styles.outerCirlcle}>
                      <img src={crone} alt="" />
                      <div className="bullets">
                        <span className="bulletone"></span>
                        <span className="bullettwo"></span>
                        <span className="bulletthree"></span>
                      </div>
                    </div>
                    <div className={styles.CountryInCircle}>
                      <div className={styles.topHeadFlag}>
                        <h4>{bundles[0]?.name}<img src={bundles[0]?.flagImageUrl} alt="" /></h4>
                        <ul>
                          <li>
                            <div className={styles.innerPlabs}>
                              <span>Data</span>
                              <h6>{(bundles[0]?.dataAmount)}</h6>
                            </div>
                          </li>
                          <li>
                            <div className={styles.innerPlabs}>
                              <span>Validity</span>
                              <h6>{bundles[0]?.duration} Days</h6>
                            </div>
                          </li>
                          <li>
                            <div className={styles.innerPlabs}>
                              <span>Speed</span>
                              <h6>{bundles[0]?.speed && bundles[0].speed.length > 0 ? bundles[0].speed.slice(-1) : 'Speed not Found'}</h6>
                            </div>
                          </li>
                        </ul>
                        <div className={styles.layBtn}>
                          <button aria-label="Buy Now esim" onClick={(e) => createOrder(bundles[0]._id)} >Buy Now </button>
                        </div>
                      </div>
                    </div>
                  </div> */}
              </div>
            </div>
          </div>
        </div>
        {/* <div className={styles.outreHomeside}>
            <img
              className={styles.bnrImage}
              width="1920"
              height="310"
              src={slone}
              alt="International eSim"
              loading="lazy"
            />
            <div className={styles.innerHomeSlide}>
              <div className="row">
                <div className="col-md-4"></div>
                <div className="col-md-8">
                   <div className={`${styles.dotstwo} ${styles.innerHomeSlideRight}`}>
                    <div className={styles.outerCirlcle}>
                      <img src={crtwo} alt="" />
                      <div className="bullets">
                        <span className="bulletone"></span>
                        <span className="bullettwo"></span>
                        <span className="bulletthree"></span>
                      </div>
                    </div>
                    <div className={styles.CountryInCircle}>
                      <div className={styles.topHeadFlag}>
                        <h4>{bundles[1]?.name}<img src={bundles[1]?.flagImageUrl} alt="" /></h4>
                        <ul>
                          <li>
                            <div className={styles.innerPlabs}>
                              <span>Data</span>
                              <h6>{(bundles[1]?.dataAmount)}</h6>
                            </div>
                          </li>
                          <li>
                            <div className={styles.innerPlabs}>
                              <span>Validity</span>
                              <h6>{bundles[1]?.duration} Days</h6>
                            </div>
                          </li>
                          <li>
                            <div className={styles.innerPlabs}>
                              <span>Speed</span>
                              <h6>{bundles[1]?.speed && bundles[1].speed.length > 0 ? bundles[1].speed.slice(-1) : 'Speed not Found'}</h6>
                            </div>
                          </li>
                        </ul>
                        <div className={styles.layBtn}>
                          <button onClick={(e) => createOrder(bundles[1]._id)} >Buy Now </button>
                        </div>
                      </div>
                    </div>
                  </div> 
                  <div className={styles.afordableSim}>
                    <h4>Affordable eSIM.<br /> Global Connectivity.<br /> Unlimited Freedom.</h4>
                  </div> 
                </div>
              </div>
            </div>
          </div> */}

        {/* <div className={styles.outreHomeside}>
            <img
              width="1920"
              height="310"
              className={styles.bnrImage}
              src={sltwo}
              alt="Travel eSim"
              loading="lazy"
            />
            <div className={styles.innerHomeSlide}>
              <div className="row">
                <div className="col-md-4"></div>
                <div className="col-md-8">
                  <div className={`${styles.dotsthree} ${styles.innerHomeSlideRight}`}>
                    <div className={styles.outerCirlcle}>
                      <img src={crthree} alt="" />
                      <div className="bullets">
                        <span className="bulletone"></span>
                        <span className="bullettwo"></span>
                        <span className="bulletthree"></span>
                      </div>
                    </div>
                    <div className={styles.CountryInCircle}>
                      <div className={styles.topHeadFlag}>
                        <h4>{bundles[2]?.name}<img src={bundles[2]?.flagImageUrl} alt="" /></h4>
                        <ul>
                          <li>
                            <div className={styles.innerPlabs}>
                              <span>Data</span>
                              <h6>{(bundles[2]?.dataAmount)}</h6>
                            </div>
                          </li>
                          <li>
                            <div className={styles.innerPlabs}>
                              <span>Validity</span>
                              <h6>{bundles[2]?.duration} Days</h6>
                            </div>
                          </li>
                          <li>
                            <div className={styles.innerPlabs}>
                              <span>Speed</span>
                              <h6>{bundles[2]?.speed && bundles[2].speed.length > 0 ? bundles[2].speed.slice(-1) : 'Speed not Found'}</h6>
                            </div>
                          </li>
                        </ul>
                        <div className={styles.layBtn}>
                          <button onClick={() => createOrder(bundles[2]._id)} >Buy Now </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {<div className={styles.afordableSim}>
                    <h4>Affordable eSIM.<br /> Global Connectivity.<br /> Unlimited Freedom.</h4>
                  </div>}
                </div>
              </div>
            </div>
          </div> */}

        {/* </Suspense> */}
        <div className={styles.innerHomeSlideLeft}>
          <div className="stay-new">
            <h3 className="mb-3 text-white">
              An eSIM that travels <br/>wherever you go
            </h3>
            <p className="py-2 text-white">
              <b>
                Go global, Stay local
              </b>
            </p>
            <h6 className="text-white gap-4 d-flex flex-wrap">
              <span><i className="me-1"><img src={check} alt="" /></i>{STRINGS.STAY_NEW_HEADING_PART_1} </span>
              <span><i className="me-1"><img src={check} alt="" /></i>{STRINGS.STAY_NEW_HEADING_PART_2}</span>
              <span><i className="me-1"><img src={check} alt="" /></i>{STRINGS.STAY_NEW_HEADING_PART_3}</span>
            </h6>
          </div>
          {/* <div className={styles.afordableSim}>
            <h4>
              {STRINGS.AFFORDABLE_SIM_LINE_1}
              <br /> {STRINGS.AFFORDABLE_SIM_LINE_2}
              <br /> {STRINGS.AFFORDABLE_SIM_LINE_3}
            </h4>
          </div> */}

          {/* <div className={styles.SimpleSearch}>
            <span><img src={srchic} alt="" /></span>
            <input type="text" placeholder="Search Destination" />
            <button>Search</button>
          </div> */}
          {/* <div className="diaCountImg">
            <img src={disc} alt="" />
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default HomeBanner;
